import type { StreamStateValue } from "../types/streamState";

const startingMessage = "starting";
const stoppedMessage = "stopped";

export const hasStoppedMessage = (streamStateMessage: unknown): boolean => {
  if (typeof streamStateMessage !== "string") {
    return false;
  }
  return streamStateMessage.trim().toLowerCase().includes(stoppedMessage);
};

export const isStreamStartingState = (
  streamState: StreamStateValue | null | undefined,
  streamStateMessage: unknown
): boolean => {
  if ((streamState ?? "unknown") !== "unknown") {
    return false;
  }
  if (typeof streamStateMessage !== "string") {
    return false;
  }
  return streamStateMessage.trim().toLowerCase() === startingMessage;
};

export const isStreamRunningState = (
  streamState: StreamStateValue | null | undefined,
  streamStateMessage: unknown
): boolean => {
  if (hasStoppedMessage(streamStateMessage)) {
    return false;
  }

  return (
    streamState === "online" ||
    streamState === "timeout" ||
    streamState === "offline" ||
    streamState === "error"
  );
};

export const shouldShowStreamActivitySpinner = (
  streamState: StreamStateValue | null | undefined,
  streamStateMessage: unknown
): boolean => {
  if ((streamState ?? "unknown") === "unknown") {
    return false;
  }

  return !hasStoppedMessage(streamStateMessage);
};

export const isStreamConfigReadOnly = (
  streamState: StreamStateValue | null | undefined,
  streamStateMessage: unknown,
  pendingCommand?: "start" | "stop"
): boolean => {
  if (pendingCommand === "start") return true;
  if (hasStoppedMessage(streamStateMessage)) return false;
  return streamState === "connecting" ||
    isStreamStartingState(streamState, streamStateMessage) ||
    isStreamRunningState(streamState, streamStateMessage);
};
